import React from "react";

export default function WarningModal({ form, submitting, onCancel, onConfirm }) {
  return (
    <div className="sx-warning-overlay">
      <div className="sx-sendx-confirm-modal">
        <div className="sx-confirm-icon">⚠</div>

        <div className="sx-confirm-content">
          <h2>Are you sure?</h2>

          <p>
            You are about to submit campaign{" "}
            <strong>{form.name || "right now"}</strong> right now. Your
            newsletter campaign will start sending immediately.
          </p>

          <div className="sx-confirm-actions">
            <button type="button" onClick={onCancel} disabled={submitting}>
              Cancel
            </button>

            <button
              type="button"
              className="submit"
              onClick={onConfirm}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}